import {
    ApiDeletedMessage,
    ApiEditMessage,
    EditEnum,
    GetUpdatedMessagesRequest,
    isApiMessage,
    MessageAttachment,
    MessageCase,
    MessageTextType,
    SendMessageRequest,
    Sticker
} from "../../models/Dialogs/message"
import { dialogsApi } from "../../api/controllers/dialogs"
import { convertRequestToResponse } from "../message/convertRequestToResponse"
import { DeleteMessageBody, EditMessageBody } from "../../models/Dialogs/dialog"
import { v4 as uuidv4 } from "uuid"
import { Dispatch } from "../common/storeHelper"

// TODO: требует доработки или полного удаления в будущем
export const updateDialogMessageEditType = (
    dispatch: Dispatch,
    currentMessagePagination: GetUpdatedMessagesRequest,
    messageIdToDelete: string,
    messageIdToCreate: string,
    editType: EditEnum,
    attachments: MessageAttachment[] = [],
    text?: string,
    sticker?: Sticker
) => {
    return dispatch(
        dialogsApi.util.updateQueryData("getDialogMessages", currentMessagePagination, draft => {
            const index = draft.Messages.findIndex(message => message.Fields.Id === messageIdToDelete)
            if (index !== -1) {
                const storedMessage = draft.Messages[index]
                if (isApiMessage(storedMessage)) {
                    draft.Messages.splice(index, 1)
                    switch (editType) {
                        case EditEnum.Deleted:
                            draft.Messages.push({
                                Case: storedMessage.Case,
                                Fields: {
                                    ...storedMessage.Fields,
                                    Id: messageIdToCreate,
                                    EditType: editType
                                }
                            })
                            break
                        case EditEnum.Edited:
                            const formattedMessage = {
                                ...storedMessage,
                                Fields: {
                                    ...storedMessage.Fields,
                                    Id: messageIdToCreate,
                                    EditType: editType,
                                    Attachments: attachments,
                                    Sticker: sticker
                                }
                            }
                            draft.Messages.push(formattedMessage)
                            break
                        default:
                            break
                    }
                }
            }
        })
    )
}

export const addDeleteEventToMessages = (
    dispatch: Dispatch,
    currentMessagePagination: GetUpdatedMessagesRequest,
    deletedMessage: DeleteMessageBody
) => {
    dispatch(
        dialogsApi.util.updateQueryData("getDialogMessages", currentMessagePagination, draft => {
            const deleteMessageRecord: ApiDeletedMessage = {
                Case: MessageCase.DeletedByOperator,
                Fields: {
                    DeletedMessageId: deletedMessage.Id,
                    DialogId: deletedMessage.DialogId,
                    Id: uuidv4(),
                    Timestamp: Date.now()
                }
            }

            draft.Messages.push(deleteMessageRecord)
        })
    )
}

export const addEditEventToMessages = (
    dispatch: Dispatch,
    currentMessagePagination: GetUpdatedMessagesRequest,
    operatorId: string,
    editMessage: EditMessageBody
) => {
    dispatch(
        dialogsApi.util.updateQueryData("getDialogMessages", currentMessagePagination, draft => {
            const editMessageRecord: ApiEditMessage = {
                Case: MessageCase.EditedByOperator,
                Fields: {
                    Id: uuidv4(),
                    MessageType: 1,
                    TextType: MessageTextType.Markdown,
                    Direction: 1,
                    Sender: { Id: operatorId },
                    DialogId: editMessage.DialogId,
                    AddedDate: Date.now(),
                    Context: [[]],
                    Status: 0,
                    EditedMessageId: editMessage.Id,
                    Attachments: editMessage.Attachments ? editMessage.Attachments : [],
                    Sticker: editMessage.Sticker,
                    ChannelId: editMessage.ChannelId,
                    Meta: {},
                    Actions: [],
                    Text: editMessage.Text
                }
            }

            draft.Messages.push(editMessageRecord)
        })
    )
}

export const updateDialogMessageQuery = (
    dispatch: Dispatch,
    currentMessagePagination: GetUpdatedMessagesRequest,
    messageIdToDelete: string,
    messageIdToCreate: string,
    updateMessage: SendMessageRequest,
    operatorId: string
) => {
    return dispatch(
        dialogsApi.util.updateQueryData("getDialogMessages", currentMessagePagination, draft => {
            const index = draft.Messages.findIndex(message => message.Fields.Id === messageIdToDelete)
            if (index !== -1) {
                const draft1 = draft.Messages[index]
                if (isApiMessage(draft1) && updateMessage && operatorId) {
                    draft.Messages.splice(index, 1)
                    draft.Messages.push(convertRequestToResponse(updateMessage, operatorId, messageIdToCreate))
                }
            }
        })
    )
}
